import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);


// other colors see https://www.figma.com/file/hZqjBqo9Gz2RP6ERZYfWFh/Brand-Bible?node-id=411%3A2
// goldenrod 100 - E3BC3B
// burgundy 100 - 52050a

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#003049',
        secondary: '#617e8d',
        accent: '#E3BC3B',
        error: '#ba3f1d',
        info: '#8eae90',
        success: '#5e8c61',
        warning: '#c8654a'
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg', //see list at https://materialdesignicons.com/, prepend with mdi-
  },
});